export const NB_ITEMS_PER_PAGE = 10;